module.exports = __webpack_public_path__ + "img/main_functions.fc095b97.svg";